export class menu{

    language:string;
    jou_uid:string="d32275f4-f952-4966-9dfb-8f5164c6f976";
    title:string;
    name:string;
    cat_id:string;
    pid: string;
    external_link: string;
    a_target: string;
    pid_name: string;
    is_active: string;
    content_type: string; 
    sort: string;
    children:menu[]=[];

}